import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import MarkupModule from "./MarkupModule";
import axios from "axios";
import "./rms.css";
import { path } from "../../../order_managment/constants/apiPath";
import { NotificationManager } from "react-notifications";
import { getUserData } from "../../common/utility/Utils";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";

const Sell = () => {
  const [value, setValue] = useState("FREIGHT");

  const [markData, setMarkData] = useState({
    originCode: "",
    mode: "FREIGHT",
    markUpMode: "",
    markUpMagnitude: "",
  });

  const getApplyMarkUp = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url;
    if (value === "FREIGHT") {
      url = `${baseUrlRate}${path.SELL_FREIGHT}`;
    } else {
      url = `${baseUrlRate}${path.SELL_IPI}`;
    }
    axios
      .put(
        url,
        {
          originCode: markData.originCode,
          markUpMode: markData.markUpMode,
          markUpMagnitude: markData.markUpMagnitude,
        },
        {
          headers: header,
        }
      )

      .then((res) => {
        console.log(res);
        NotificationManager.success("Markup applied sucessfully!", "", 3000);
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error("Markup not applied !", "", 3000);
      });
  };

  const handleChange = (event, newValue) => {
    setMarkData({
      ...markData,
      mode: newValue,
      originCode: "",
      markUpMode: "",
      markUpMagnitude: "",
    });
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(event, value) => {
                handleChange(event, value);
              }}
              aria-label="lab API tabs example"
            >
              <Tab label="FREIGHT" value="FREIGHT" />
              <Tab label="IPI" value="IPI" />
            </TabList>
          </Box>
          {["FREIGHT", "IPI"].map((item, index) => {
            return (
              <TabPanel key={index} value={item}>
                <MarkupModule
                  markData={markData}
                  setMarkData={setMarkData}
                  getApplyMarkUp={getApplyMarkUp}
                  data={item}
                  value={value}
                />
              </TabPanel>
            );
          })}
        </TabContext>
      </Box>
    </>
  );
};

export default Sell;
